export const TestPrepVariantMap = {
  'Extended Constructed Response': {
    variants: {
      'PA PSSA ELA Text-Dependent Analysis':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::PA PSSA ELA Text-Dependent Analysis',
      'MI M-STEP ELA Passage-based Writing':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::MI M-STEP ELA Passage-based Writing',
      'TX STAAR ELA Informational ECR':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TX STAAR ELA Informational ECR',
      'TX STAAR ELA Argumentative ECR':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TX STAAR ELA Argumentative ECR',
      'TX STAAR ELA Correspondence ECR':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TX STAAR ELA Correspondence ECR',
      'NY NYSTP ELA 4-Point Constructed Response Question':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::NY NYSTP ELA 4-Point Constructed Response Question',
      'NY NYSTP ELA Text-Analysis Question':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::NY NYSTP ELA Text-Analysis Question',
      'NY NYSTP ELA Writing from Sources Argument Essay':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::NY NYSTP ELA Writing from Sources Argument Essay',
      'AZ AASA ELA Informative Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AZ AASA ELA Informative Extended Response',
      'AZ AASA ELA Opinion Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AZ AASA ELA Opinion Extended Response',
      'AZ AASA ELA Argumentative Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AZ AASA ELA Argumentative Extended Response',
      'OH OST ELA Informative Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::OH OST ELA Informative Extended Response',
      'OH OST ELA Opinion Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::OH OST ELA Opinion Extended Response',
      'OH OST ELA Argumentation Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::OH OST ELA Argumentation Extended Response',
      'FL BEST ELA Expository Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::FL BEST ELA Expository Extended Response',
      'EL BEST ELA Argumentation Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::EL BEST ELA Argumentation Extended Response',
      'TN TCAP ELA 3rd Grade Informational Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA 3rd Grade Informational Extended Response',
      'TN TCAP ELA 3rd Grade Opinion Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA 3rd Grade Opinion Extended Response',
      'TN TCAP ELA 3rd Grade Narrative Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA 3rd Grade Narrative Extended Response',
      'TN TCAP ELA Informational Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA Informational Extended Response',
      'TN TCAP ELA Opinion Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA Opinion Extended Response',
      'TN TCAP ELA Argument Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA Argument Extended Response',
      'TN TCAP ELA Narrative Extended Response':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::TN TCAP ELA Narrative Extended Response',
      'AL ACAP ELA Informative Explanatory Text-Dependent Writing':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AL ACAP ELA Informative Explanatory Text-Dependent Writing',
      'AL ACAP ELA Argumentative Text-Dependent Writing':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AL ACAP ELA Argumentative Text-Dependent Writing',
      'AL ACAP ELA Narrative Text-Dependent Writing':
        'b6db9100-70ad-480c-a43e-7fbc63719c9d::AL ACAP ELA Narrative Text-Dependent Writing',
    },
  },
  'Math Performance Task Simulation': {
    variants: {
      'CA CAASPP Math Performance Task':
        'd5a1b57c-3015-4d42-b3a6-c6f00862f621::CA CAASPP Math Performance Task',
      'Multi SBAC Math Performance Task':
        'd5a1b57c-3015-4d42-b3a6-c6f00862f621::Multi SBAC Math Performance Task',
    },
  },
  'Math Constructed Response Question': {
    variants: {
      'TX STAAR Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::TX STAAR Math 1-Point',
      'AZ ASSA Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::AZ ASSA Math 1-Point',
      'AL ACAP Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::AL ACAP Math 1-Point',
      'TN TCAP Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::TN TCAP Math 1-Point',
      'GA GMAS Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::GA GMAS Math 1-Point',
      'NC EOG Math 1-Point': '72aa8efc-c52c-44e3-b44c-313f418818ee::NC EOG Math 1-Point',
      'FL FAST Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::FL FAST Math 1-Point',
      'OH OST Math 1-Point': '72aa8efc-c52c-44e3-b44c-313f418818ee::OH OST Math 1-Point',
      'MI M-STEP Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::MI M-STEP Math 1-Point',
      'NY NYSTP Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::NY NYSTP Math 1-Point',
      'Multi SBAC Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::Multi SBAC Math 1-Point',
      'CA CAASPP Math 1-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::CA CAASPP Math 1-Point',
      'CA CAASPP Math 2-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::CA CAASPP Math 2-Point',
      'NY NYSTP Math 2-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::NY NYSTP Math 2-Point',
      'MI M-STEP Math 2-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::MI M-STEP Math 2-Point',
      'Multi SBAC Math 2-Point':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::Multi SBAC Math 2-Point',
      'TX STAAR Math 2-Pont 2-Part':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::TX STAAR Math 2-Pont 2-Part',
      'GA GMAS Math 2-Point 2-Part':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::GA GMAS Math 2-Point 2-Part',
      'AZ AASA Math 2-Point 2-Part':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::AZ AASA Math 2-Point 2-Part',
      'FL FAST Math 2-Point 2-Part':
        '72aa8efc-c52c-44e3-b44c-313f418818ee::FL FAST Math 2-Point 2-Part',
      'CA CAASPP Math 3-Point':
        '846b2223-dbf5-4dff-b4f2-bc9c7727669d::CA CAASPP Math 3-Point',
      'MI M-STEP Math 3-Point':
        '846b2223-dbf5-4dff-b4f2-bc9c7727669d::MI M-STEP Math 3-Point',
      'NY NYSTP 3-Point': '846b2223-dbf5-4dff-b4f2-bc9c7727669d::NY NYSTP 3-Point',
      'Multi SBAC Math 3-Point':
        '846b2223-dbf5-4dff-b4f2-bc9c7727669d::Multi SBAC Math 3-Point',
      'CA CAASPP 4-Point': '846b2223-dbf5-4dff-b4f2-bc9c7727669d::CA CAASPP 4-Point',
      'MI M-STEP Math 4-Point':
        '846b2223-dbf5-4dff-b4f2-bc9c7727669d::MI M-STEP Math 4-Point',
      'Multi SBAC Math 4-Point':
        '846b2223-dbf5-4dff-b4f2-bc9c7727669d::Multi SBAC Math 4-Point',
    },
  },
  'Performance Task Component': {
    variants: {
      'CA CAASPP Math Performance Task 1-Point':
        'b98defc8-6f19-404f-9089-02a7b498bb14::CA CAASPP Math Performance Task 1-Point',
      'Multi SBAC Math Performance Task 1-Point':
        'b98defc8-6f19-404f-9089-02a7b498bb14::Multi SBAC Math Performance Task 1-Point',
      'CA CAASPP Math Performance Task 2-Point':
        'b98defc8-6f19-404f-9089-02a7b498bb14::CA CAASPP Math Performance Task 2-Point',
      'Multi SBAC Math Performance Task 2-Point':
        'b98defc8-6f19-404f-9089-02a7b498bb14::Multi SBAC Math Performance Task 2-Point',
      'CA CAASPP Performance Task 3-Point':
        '69c79e12-3f3c-48c1-be0d-87e657538a83::CA CAASPP Performance Task 3-Point',
      'Multi SBAC Performance Task 3-Point':
        '69c79e12-3f3c-48c1-be0d-87e657538a83::Multi SBAC Performance Task 3-Point',
      'CA CAASPP Performance Task 4-Point':
        '69c79e12-3f3c-48c1-be0d-87e657538a83::CA CAASPP Performance Task 4-Point',
      'Multi SBAC Performance Task 4-Point':
        '69c79e12-3f3c-48c1-be0d-87e657538a83::Multi SBAC Performance Task 4-Point',
    },
  },
  'Writing Performance Task': {
    variants: {
      'CA CAASPP ELA Informational Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::CA CAASPP ELA Informational Performance Task',
      'CA CAASPP ELA Opinion Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::CA CAASPP ELA Opinion Performance Task',
      'CA CAASPP Argumentative Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::CA CAASPP Argumentative Performance Task',
      'CA CAASPP Narrative Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::CA CAASPP Narrative Performance Task',
      'SBAC ELA Informational Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::SBAC ELA Informational Performance Task',
      'SBAC ELA Opinion Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::SBAC ELA Opinion Performance Task',
      'SBAC ELA Argumentative Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::SBAC ELA Argumentative Performance Task',
      'SBAC ELA Narrative Performance Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::SBAC ELA Narrative Performance Task',
      'GA GMAS ELA Extended Writing Task':
        'd57e0069-e424-4d5c-a290-d0ab5c0b6f5f::GA GMAS ELA Extended Writing Task',
    },
  },
  'Use My Materials - Short Constructed Response': {
    variants: {
      'AZ AASA ELA Short Answer Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::AZ AASA ELA Short Answer Curify',
      'TX STAAR ELA SCR Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::TX STAAR ELA SCR Curify',
      'CA CAASPP ELA Short Answer Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::CA CAASPP ELA Short Answer Curify',
      'SBAC ELA Short Answer Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::SBAC ELA Short Answer Curify',
      'NC NCPAT ELA Reading Short Constructed Response Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::NC NCPAT ELA Reading Short Constructed Response Curify',
      'NY NYSTEP ELA 2-Credit Constructed Response Question Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::NY NYSTEP ELA 2-Credit Constructed Response Question Curify',
      'PA PSSA ELA Reading Short-Answer Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::PA PSSA ELA Reading Short-Answer Curify',
      'PA PSSA ELA Literature EOC Constructed Response Curify':
        'bbf41d56-5abf-4e5b-b800-f203c91d3a4c::PA PSSA ELA Literature EOC Constructed Response Curify',
    },
  },
  'Paired Passage Extended Constructed Response': {
    variants: {
      'TX STAAR ELA Informational ECR':
        'de25e0f7-6681-4951-9434-e9975769a411::TX STAAR ELA Informational ECR',
      'TX STAAR ELA Argumentative ECR':
        'de25e0f7-6681-4951-9434-e9975769a411::TX STAAR ELA Argumentative ECR',
      'TX STAAR ELA Correspondence ECR':
        'de25e0f7-6681-4951-9434-e9975769a411::TX STAAR ELA Correspondence ECR',
    },
  },
  'Use My Materials - Paired Passage Extended Constructed Response': {
    variants: {
      'TX STAAR ELA Informational ECR':
        '32457ab2-b396-48df-a951-e51524445442::TX STAAR ELA Informational ECR',
      'TX STAAR ELA Argumentative ECR':
        '32457ab2-b396-48df-a951-e51524445442::TX STAAR ELA Argumentative ECR',
      'TX STAAR ELA Correspondence ECR':
        '32457ab2-b396-48df-a951-e51524445442::TX STAAR ELA Correspondence ECR',
    },
  },
  'Short Constructed Response': {
    variants: {
      'AZ AASA ELA Short Answer':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::AZ AASA ELA Short Answer',
      'TX STAAR ELA SCR': '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::TX STAAR ELA SCR',
      'CA CAASPP ELA Short Answer':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::CA CAASPP ELA Short Answer',
      'SBAC ELA Short Answer':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::SBAC ELA Short Answer',
      'NC NCPAT ELA Reading Short Constructed Response':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::NC NCPAT ELA Reading Short Constructed Response',
      'NY NYSTEP ELA 2-Credit Constructed Response Question':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::NY NYSTEP ELA 2-Credit Constructed Response Question',
      'PA PSSA ELA Reading Short-Answer':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::PA PSSA ELA Reading Short-Answer',
      'PA PSSA ELA Literature EOC Constructed Response':
        '97104b0b-4b24-4a3d-85e6-6cfdf371a1cc::PA PSSA ELA Literature EOC Constructed Response',
    },
  },
  'Paired Passage Short Constructed Response': {
    variants: {
      'AZ AASA ELA Short Answer Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::AZ AASA ELA Short Answer Paired Passages',
      'TX STAAR ELA SCR Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::TX STAAR ELA SCR Paired Passages',
      'CA CAASPP ELA Short Answer Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::CA CAASPP ELA Short Answer Paired Passages',
      'SBAC ELA Short Answer Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::SBAC ELA Short Answer Paired Passages',
      'NC NCPAT ELA Reading Short Constructed Response Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::NC NCPAT ELA Reading Short Constructed Response Paired Passages',
      'NY NYSTEP ELA 2-Credit Constructed Response Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::NY NYSTEP ELA 2-Credit Constructed Response Paired Passages',
      'PA PSSA ELA Reading Short-Answer Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::PA PSSA ELA Reading Short-Answer Paired Passages',
      'PA PSSA ELA Literature EOC Constructed Response Paired Passages':
        '56d281ba-7a95-49a2-8683-ad094d8b6bf1::PA PSSA ELA Literature EOC Constructed Response Paired Passages',
    },
  },
  'Use My Materials - Extended Constructed Response': {
    variants: {
      'PA PSSA ELA Text-Dependent Analysis Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::PA PSSA ELA Text-Dependent Analysis Curify',
      'MI M-STEP ELA Passage-based Writing Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::MI M-STEP ELA Passage-based Writing Curify',
      'TX STAAR ELA Informational ECR Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TX STAAR ELA Informational ECR Curify',
      'TX STAAR ELA Argumentative ECR Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TX STAAR ELA Argumentative ECR Curify',
      'TX STAAR ELA Correspondence ECR Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TX STAAR ELA Correspondence ECR Curify',
      'NY NYSTP ELA 4-Point Constructed Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::NY NYSTP ELA 4-Point Constructed Response Curify',
      'NY NYSTP ELA Text-Analysis Question Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::NY NYSTP ELA Text-Analysis Question Curify',
      'NY NYSTP ELA Writing from Sources Argument Essay Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::NY NYSTP ELA Writing from Sources Argument Essay Curify',
      'AZ AASA ELA Informative Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AZ AASA ELA Informative Extended Response Curify',
      'AZ AASA ELA Opinion Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AZ AASA ELA Opinion Extended Response Curify',
      'AZ AASA ELA Argumentative Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AZ AASA ELA Argumentative Extended Response Curify',
      'OH OST ELA Informative Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::OH OST ELA Informative Extended Response Curify',
      'OH OST ELA Opinion Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::OH OST ELA Opinion Extended Response Curify',
      'OH OST ELA Argumentation Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::OH OST ELA Argumentation Extended Response Curify',
      'FL BEST ELA Expository Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::FL BEST ELA Expository Extended Response Curify',
      'FL BEST ELA Argumentation Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::FL BEST ELA Argumentation Extended Response Curify',
      'TN TCAP ELA 3rd Grade Informational Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA 3rd Grade Informational Extended Response Curify',
      'TN TCAP ELA 3rd Grade Opinion Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA 3rd Grade Opinion Extended Response Curify',
      'TN TCAP ELA 3rd Grade Narrative Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA 3rd Grade Narrative Extended Response Curify',
      'TN TCAP ELA Informational Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA Informational Extended Response Curify',
      'TN TCAP ELA Opinion Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA Opinion Extended Response Curify',
      'TN TCAP ELA Argument Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA Argument Extended Response Curify',
      'TN TCAP ELA Narrative Extended Response Curify':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::TN TCAP ELA Narrative Extended Response Curify',
      'AL ACAP ELA Informative Explanatory Text-Dependent Writing':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AL ACAP ELA Informative Explanatory Text-Dependent Writing',
      'AL ACAP ELA Argumentative Text-Dependent Writing':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AL ACAP ELA Argumentative Text-Dependent Writing',
      'AL ACAP ELA Narrative Text-Dependent Writing':
        '51c4e5bd-7abc-449d-8f20-fe27f71fcc96::AL ACAP ELA Narrative Text-Dependent Writing',
    },
  },
  'Use My Materials - Paired Passage Short Constructed Response': {
    variants: {
      'AZ AASA ELA Short Answer Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::AZ AASA ELA Short Answer Paired Passage Curify',
      'TX STAAR ELA SCR Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::TX STAAR ELA SCR Paired Passage Curify',
      'CA CAASPP ELA Short Answer Paired Passage Curity':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::CA CAASPP ELA Short Answer Paired Passage Curity',
      'SBAC ELA Short Answer Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::SBAC ELA Short Answer Paired Passage Curify',
      'NC NCPAT ELA Reading Short Constructed Response Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::NC NCPAT ELA Reading Short Constructed Response Paired Passage Curify',
      'NY NYSTEP ELA 2-Credit Constructed Response Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::NY NYSTEP ELA 2-Credit Constructed Response Paired Passage Curify',
      'PA PSSA ELA Reading Short-Answer Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::PA PSSA ELA Reading Short-Answer Paired Passage Curify',
      'PA PSSA ELA Literature EOC Constructed Response Paired Passage Curify':
        'e1ecadbc-2623-4c55-9bf4-f0cab0d637d7::PA PSSA ELA Literature EOC Constructed Response Paired Passage Curify',
    },
  },
  'Use My Materials - Writing Performance Task': {
    variants: {
      'CA CAASPP ELA Informational Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::CA CAASPP ELA Informational Performance Task Curify',
      'CA CAASPP ELA Opinion Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::CA CAASPP ELA Opinion Performance Task Curify',
      'CA CAASPP Argumentative Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::CA CAASPP Argumentative Performance Task Curify',
      'CA CAASPP Narrative Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::CA CAASPP Narrative Performance Task Curify',
      'SBAC ELA Informational Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::SBAC ELA Informational Performance Task Curify',
      'SBAC ELA Opinion Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::SBAC ELA Opinion Performance Task Curify',
      'SBAC ELA Argumentative Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::SBAC ELA Argumentative Performance Task Curify',
      'SBAC ELA Narrative Performance Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::SBAC ELA Narrative Performance Task Curify',
      'GA GMAS ELA Extended Writing Task Curify':
        'dfca9456-4a81-4859-89bf-0f9f98f4f411::GA GMAS ELA Extended Writing Task Curify',
    },
  },
} as const;
